export enum PeriodEnum {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export interface Stats {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  color: string;
}
